module.exports = __webpack_public_path__ + "img/completed-policies.038286d7.png";